import { Flex, Heading } from '@chakra-ui/core';
import React from 'react';
import Booking from '../util/Booking';
import { openBooking } from './Hero';

function GetStarted(props) {
  return (
    <Flex
      direction={'column'}
      justifyContent={'center'}
      bg="ghostBlue"
      py="10rem"
      px="1rem"
      mt="5rem"
      style={{ gap: '1rem' }}
    >
      <Heading fontWeight={'semibold'} className="w-100 center">
        Set up your cleaning service
      </Heading>
      <p className="center">
        Select the size of your home, see your price, and schedule a cleaning in
        60 seconds.
      </p>
      <br />
      <div className="container">
        <Booking {...props} center openBooking={openBooking} />
      </div>
    </Flex>
  );
}

export default GetStarted;
